import axios, { AxiosError } from "axios";
import { logout } from "./Slice";
import { baseUrl } from "../Common/Constants";

const unauthorized = 401;
const forbidden = 403;
const notFound = 404;

let store;

export const injectStore = (_store) => {
  store = _store;
};



const httpClient = axios.create({
  baseURL: baseUrl,
});

httpClient.interceptors.response.use(
    (response) => {
    return response;
  },
    async (error: AxiosError) => {
    if (error.message === "cancelled request") {
      return Promise.reject(error);
    }
    if (error.response !== undefined) {
      if (
        error.response.status !== forbidden &&
        error.response.status !== unauthorized &&
          error.response.status !== notFound && error.response.status !== 302 && error.response.status !== 304
      ) {
        return Promise.reject(error);
      }
      if (
          error.response.status === unauthorized 
      ) {
        store.dispatch(logout());
      //  return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default httpClient;
